import React from 'react'
import { slide as Menu } from 'react-burger-menu';
import "./Sidebar.css"
import { Link } from 'react-router-dom';
import { useStateValue } from './StateProvider';
import { auth } from './firebase';

export default props => {

    const[{basket, user },dispatch]= useStateValue();
    const handleAuthentication = () => {
      if (user) {
      auth.signOut();
      }
  }
    return (
      <Menu right >
          <Link to="/">
        <div className="menu-item" >
          Inicio
        </div>
        </Link>
        <Link to={!user && '/login'}>
        <div onClick={handleAuthentication} className="menu-item" >
        {!user ? 'Iniciar sesion' : 'Cerrar Sesion'}
        </div>
        </Link>
        <Link to="/orders">
        <div className="menu-item" >
         Ordenes
        </div>
        </Link>
        <Link to="/Lista">
        <div className="menu-item" >
          Catálogo
        </div>
        </Link>
      </Menu>
    );
  };

